import LieuConfigNiveauxController from './lieu.config.niveaux.controller';

export default {
    template: require('./lieu.config.niveaux.tpl.html'),
    controller: LieuConfigNiveauxController,
    bindings: {}
};
